import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {AppService} from '../app/app.service';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {ElectronService} from 'ngx-electron';
import {GenericHttpService} from './genericHttpService';
import {ApiService} from './api.service';
import {ConflictException} from './conflictException';


@Injectable({
  providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {
  static unauthorizedCounter = 0;


  constructor(public appService: AppService,
              private apiService: ApiService,
              private electronService: ElectronService) {
    this.appService = appService;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startsWithTenantApiClientUrl = this.isStartingWithClientBaseUrl(this.apiService.tenantApiClient, request.url);
    const startsWithAccountApiClientUrl = this.isStartingWithClientBaseUrl(this.apiService.accountApiClient, request.url);

    const shouldBypass = (startsWithTenantApiClientUrl || startsWithAccountApiClientUrl);
    if (shouldBypass) {
      return next.handle(request);
    }

    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMsg = '';
          switch (error.status) {
            case 400:
              this.appService.showErrorMessage(`${error.error.detail}`);
              break;
            case 401:
              this.appService.showErrorMessage(`There is an authentication/privilege problem. Please try logging in again.`);
              localStorage.clear();
              this.electronService.ipcRenderer.send('reload');
              break;
            case 404:
              if (!request.url.toLowerCase().endsWith('/labels')) {
                this.appService.showErrorMessage(`There is something missing on the server. Please report this occurence.`);
              }
              break;
            case 409:
              return throwError(new ConflictException(error.status, error.statusText, error.error));
            case 501:
              this.appService.showWarnMessage(`This feature is under maintenance. Please try again at a later date.`);
              break;
          }
          errorMsg = `Error: ${error.error.detail}`;
          return throwError(errorMsg);
        })
      );
  }

  isStartingWithClientBaseUrl(client: GenericHttpService, url: string): boolean {
    if (!client) {
      return false;
    }
    if (!client.baseUrl) {
      return false;
    }
    return url.startsWith(client.baseUrl);

  }
}

